import GridTextCell from './GridTextCell';
import GridDateCell from './GridDateCell';
import GridItemsCell from './GridItemsCell';
import GridSelectCell from './GridSelectCell';
import GridStatusCell from './GridStatusCell';
import GridTestDataCell from './GridTestDataCell';
import EditorSelectCell from '../grids/permissionEditor/editorCells/EditorSelectCell';
import GridLabelCell from './GridLabelCell';
import GridAmountCell from './GridAmountCell';
import GridFromToCell from './GridFromToCell';
import GridThemeCell from './GridThemeCell';
import GridUploadCell from './GridUploadCell';
import GridArrayCell from './GridArrayCell';
import GridUploadWrapCell from './GridUploadWrapCell';
import GridTranslatableCell from './GridTranslatableCell';
import GridFullDateCell from './GridFullDateCell';
import GridBooleanCell from './GridBooleanCell';
import GridEntityCell from './GridEntityCell';
import GridTagsCell from './GridTagsCell';
import GridImagePreviewCell from './GridImagePreviewCell';

const Cells = {
    Text: GridTextCell,
    Date: GridDateCell,
    FullDate: GridFullDateCell,
    Items: GridItemsCell,
    Select: GridSelectCell,
    Status: GridStatusCell,
    Label: GridLabelCell,
    TestData: GridTestDataCell,
    EditorSelect: EditorSelectCell,
    Amount: GridAmountCell,
    FromTo: GridFromToCell,
    Theme: GridThemeCell,
    Upload: GridUploadCell,
    Array: GridArrayCell,
    UploadWrap: GridUploadWrapCell,
    Translatable: GridTranslatableCell,
    Boolean: GridBooleanCell,
    Checkbox: GridBooleanCell,
    Entity: GridEntityCell,
    Tags: GridTagsCell,
    SelectLabel: GridLabelCell,
    ItemsLabel: GridLabelCell,
    WalletArray: GridArrayCell,
    ImagePreview: GridImagePreviewCell
};

export default Cells;
